import styled from 'styled-components'
import { colors } from '../../theme'

/**
 * O logo e dimensionado por `font-size`: o wordmark vale 1em e o simbolo 1.8em
 * (2.1em na versao empilhada), replicando a proporcao do manual da marca.
 * Assim basta mudar `tamanho` para escalar o conjunto inteiro.
 */
export const LogoWrapper = styled.span<{
  $vertical: boolean
  $tamanho: number
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')};
  gap: ${({ $vertical }) => ($vertical ? '0.26em' : '0.14em')};
  font-size: ${({ $tamanho }) => $tamanho}px;
`

export const Simbolo = styled.img<{ $vertical: boolean }>`
  height: ${({ $vertical }) => ($vertical ? '2.1em' : '1.8em')};
  width: auto;
  display: block;
`

export const Wordmark = styled.img`
  height: 1em;
  width: auto;
  display: block;
`

/* Tamanho fixo: em `em` a tagline cairia para ~8px no login. O peso 300 nao
   esta entre os carregados no index.html e seria sintetizado pelo navegador. */
export const Tagline = styled.span`
  font-size: 11px;
  font-weight: 400;
  line-height: 1.2;
  color: ${colors.white};
  white-space: nowrap;
  margin-top: 0.4em;

  strong {
    font-weight: 400;
    /* Sobre a chrome verde, secondary renderia 2,2:1. Ver mintPale no tema. */
    color: ${colors.mintPale};
  }
`
